// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CourseLecturerTile_wrapper__NOa5y","name":"CourseLecturerTile_name__5nWvF"};